/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type QuizSetContributorResRole =
  (typeof QuizSetContributorResRole)[keyof typeof QuizSetContributorResRole];

export const QuizSetContributorResRole = {
  QUIZSET_ORIGIN: 'QUIZSET_ORIGIN',
  QUIZ_BANK: 'QUIZ_BANK',
} as const;
